import React from 'react';
import { Box, costFormater, Inscription, NavigationToggler, Preloader } from '@common-fe/common-fe';

import { Option } from '@/common/types';

import { OrganizationPathItem, UnappliedFundsTab } from '../UnappliedFunds.types';

import OrganizationPath from './OrganizationPath';

interface Props {
  organizationName?: string;
  balance: number;
  isBalanceLoading?: boolean;
  pathItems: OrganizationPathItem[];
  onSelectPathOrganization: (organizationId: string) => void;
  tabs: Option[];
  currentTab: UnappliedFundsTab;
  onChangeTab: (tab: UnappliedFundsTab) => void;
  children: React.ReactNode;
}

const UnappliedFunds: React.FC<Props> = ({
  organizationName,
  balance,
  isBalanceLoading,
  pathItems,
  onSelectPathOrganization,
  tabs,
  currentTab,
  onChangeTab,
  children,
}) => (
  <Box data-testid="unapplied-funds" direction="column">
    {pathItems.length > 0 && (
      <Box margin={{ bottom: 'spacing8' }}>
        <OrganizationPath items={pathItems} onSelect={onSelectPathOrganization} />
      </Box>
    )}
    <Box direction="row" justify="between" align="center" margin={{ bottom: 'spacing24' }}>
      <Inscription
        data-testid="unapplied-funds_title"
        size="3xl"
        weight="bold"
        color="textBody"
        lineHeight="44px"
      >
        {organizationName ? `${organizationName} – Unapplied Funds` : ''}
      </Inscription>
      <NavigationToggler
        testId="unapplied-funds-toggler"
        value={currentTab}
        options={tabs}
        onChange={(value: string) => onChangeTab(value as UnappliedFundsTab)}
      />
    </Box>
    <Box direction="row" gap="spacing4" margin={{ bottom: 'spacing24' }}>
      <Inscription color="textBody">Unapplied funds balance:</Inscription>
      <Inscription data-testid="unapplied-funds_balance" color="textBody" weight="bold">
        {isBalanceLoading ? <Preloader testId="unapplied-funds_balance-preloader" size={16} /> : costFormater(balance, true)}
      </Inscription>
    </Box>
    {children}
  </Box>
);

export default UnappliedFunds;
